import React, { createContext, PropsWithChildren, ChangeEvent } from 'react'
import useLocalStorage from '~hooks/useLocalStorage'

const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
}
const initialState = {
  ...defaultSettings,
  onChangeMode: () => { },
  onToggleMode: () => { },
  onChangeDirection: () => { },
}

type ISettingsContext = {
  themeMode: string;
  themeDirection: string;
  onChangeMode: (data: string) => void;
  onToggleMode: () => void;
  onChangeDirection: (event: ChangeEvent<HTMLInputElement>) => void;
}

const SettingsContext = createContext<ISettingsContext>(initialState)

function SettingsProvider({ children }: PropsWithChildren) {
  const [settings, setSettings] = useLocalStorage('settings', {
    themeMode: initialState.themeMode,
    themeDirection: initialState.themeDirection,
  })

  const onToggleMode = () => {
    setSettings({
      ...settings,
      themeMode: settings.themeMode === 'light' ? 'dark' : 'light',
    })
  }

  const onChangeMode = (data: string) => {
    setSettings({
      ...settings,
      themeMode: data,
    })
  }

  const onChangeDirection = (event: ChangeEvent<HTMLInputElement>) => {
    setSettings({
      ...settings,
      themeDirection: event.target.value,
    })
  }

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        onToggleMode,
        onChangeMode,
        onChangeDirection,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}

export { SettingsProvider, SettingsContext }
